import React from 'react';
import { translate } from '../Services/translation';

export const FacetedFilterProductCount = ({filterTotalCount}) => {
    const productCountText = `${filterTotalCount} ${translate('code.facet.header.productcount.items')}`;

    return <div className="selected-filter__product-count">{productCountText}</div>;
}

export default FacetedFilterProductCount;